import mutations from './modulePurchaseTicketMutations.js';
import actions from './modulePurchaseTicketActions.js';
import getters from './modulePurchaseTicketGetters.js';
import { getDefaultState } from './constants.js';

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters,
};
